(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  const SEC = 'cart-drawer';
  const root = () => document.querySelector('[data-cd]');
  const enabled = () => { const r = root(); return r && !r.hasAttribute('data-cd-off'); };
  let lastFocus = null;
  const open = () => {
    const r = root(); if (!r) return;
    lastFocus = document.activeElement;
    r.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll');
    r.querySelector('.cd__panel')?.focus();
  };
  const close = () => {
    const r = root(); if (!r) return;
    r.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll');
    lastFocus?.focus?.();
  };
  /* One price per can, whatever the route into the cart: as soon as the cart holds more than one pack of cans,
     every 24 or 36 pack is split into packs of 12 (same flavour, same subscription), so the volume discount on the
     packs of 12 prices all cans together. Only 36 packs stay as they are, they already carry the 36 price.
     Old lines with a Flavours note are split per flavour, so the warehouse sees exactly which cans to send. */
  const tried = new Set();
  const normalize = async () => {
    const r = root(); if (!r || !enabled()) return false;
    const ls = [...r.querySelectorAll('.cd__item[data-v12]')].map((li) => ({
      n: Number(li.dataset.size), q: Number(li.dataset.qty), v12: Number(li.dataset.v12), vid: Number(li.dataset.vid),
      plan: li.dataset.plan ? Number(li.dataset.plan) : null, planName: li.dataset.planName || '', mix: li.dataset.mix || ''
    }));
    if (!ls.length) return false;
    const units = ls.reduce((a, l) => a + l.q, 0);
    const only36 = ls.every((l) => l.n === 36 && !l.mix);
    const split = ls.filter((l) => l.mix || (!only36 && units > 1 && l.n > 12));
    if (!split.length) return false;
    const sig = split.map((l) => [l.vid, l.q, l.plan, l.mix].join('|')).join(';');
    if (tried.has(sig)) return false; /* only a failed attempt is remembered, so a failing split cannot loop */
    tried.add(sig);
    let fmap = {};
    try { fmap = JSON.parse(r.querySelector('[data-cd-flv]')?.textContent || '{}'); } catch (e) {}
    const items = [];
    split.forEach((l) => {
      const packs = Math.round((l.n / 12) * l.q);
      let parts = [];
      if (l.mix) {
        parts = l.mix.split(', ').map((p) => p.match(/^(\d+)x (.+)$/)).filter(Boolean).map((m) => {
          const f = fmap[m[2]] || {};
          return { id: f.id, plan: l.plan ? (f.plans || {})[l.planName] || l.plan : null, k: Math.round(Number(m[1]) / 12) * l.q };
        });
        if (!parts.length || parts.some((p) => !p.id || p.k < 1) || parts.reduce((a, p) => a + p.k, 0) !== packs) parts = [];
      }
      if (!parts.length) parts = [{ id: l.v12, plan: l.plan, k: packs }];
      parts.forEach((p) => { const it = { id: p.id, quantity: p.k }; if (p.plan) it.selling_plan = p.plan; items.push(it); });
    });
    try {
      /* add the packs of 12 first, so nothing is lost if that fails, then drop the old lines */
      await post(NJS.routes.cart_add_url + '.js', { items });
      const cart = await (await fetch(`${NJS.routes.cart_url}.js`)).json();
      const updates = {};
      cart.items.forEach((i) => {
        const plan = i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : null;
        const mix = (i.properties && i.properties.Flavours) || '';
        if (split.some((l) => l.vid === i.variant_id && l.plan === plan && l.mix === mix)) updates[i.key] = 0;
      });
      if (Object.keys(updates).length) await post(`${NJS.routes.cart_url}/update.js`, { updates });
      tried.delete(sig);
      return true;
    } catch (e) { console.error(e); return false; }
  };
  const render = async (depth = 0) => {
    const res = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}?sections=${SEC}&t=${Date.now()}`);
    const data = await res.json();
    const doc = new DOMParser().parseFromString(data[SEC], 'text/html');
    const fresh = doc.querySelector('.cd__panel'); const r = root();
    if (fresh && r) r.querySelector('.cd__panel').innerHTML = fresh.innerHTML;
    if (depth < 2 && await normalize()) return render(depth + 1);
    const cart = await (await fetch(`${NJS.routes.cart_url}.js`)).json();
    document.querySelectorAll('[data-cart-count]').forEach((c) => (c.textContent = cart.item_count));
    return cart;
  };
  const busy = async (fn) => {
    const r = root(); r?.classList.add('is-busy');
    try { await fn(); await render(); } catch (e) { console.error(e); } finally { r?.classList.remove('is-busy'); }
  };
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
    .then(async (r) => { if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.description || d.message || 'Cart error'); } return r.json(); });

  document.addEventListener('click', (e) => {
    const r = root(); if (!r || !enabled()) return;
    const link = e.target.closest('a[href]');
    if (link && !r.contains(link)) {
      const u = new URL(link.href, location.href);
      if (u.origin === location.origin && u.pathname.replace(/\/$/, '').endsWith(NJS.routes.cart_url) && !document.body.classList.contains('template-cart')) {
        e.preventDefault(); open(); return;
      }
    }
    if (!r.contains(e.target)) return;
    if (e.target.closest('[data-cd-close]')) { close(); return; }
    const item = e.target.closest('[data-key]');
    const q = e.target.closest('[data-cd-qty]');
    if (q && item) { busy(() => post(`${NJS.routes.cart_url}/change.js`, { id: item.dataset.key, quantity: Number(q.dataset.cdQty) })); return; }
    const p = e.target.closest('[data-cd-plan]');
    if (p && item) {
      const qty = Number(item.dataset.qty || item.querySelector('.cd__qty span')?.textContent || 1);
      const plan = p.dataset.cdPlan ? Number(p.dataset.cdPlan) : null;
      busy(() => post(`${NJS.routes.cart_url}/change.js`, { id: item.dataset.key, quantity: qty, selling_plan: plan }));
      return;
    }
    const sw = e.target.closest('[data-cd-swap]');
    if (sw && item) {
      const line = { id: Number(sw.dataset.cdSwap), quantity: 1 };
      if (sw.dataset.plan) line.selling_plan = Number(sw.dataset.plan);
      /* mixed packs: grow or shrink the flavour split along with the pack */
      if (item.dataset.mix) {
        const main = item.dataset.main, diff = Number(sw.dataset.to || 0) - Number(item.dataset.size || 0);
        const parts = item.dataset.mix.split(', ').map((p) => { const m = p.match(/^(\d+)x (.+)$/); return m ? { n: Number(m[1]), name: m[2] } : null; }).filter(Boolean);
        if (parts.length && diff) {
          if (diff > 0) { const mp = parts.find((p) => p.name === main); if (mp) mp.n += diff; else parts.push({ n: diff, name: main }); }
          else {
            let cut = -diff;
            parts.slice().sort((a, b) => (a.name === main) - (b.name === main) || a.n - b.n).forEach((p) => { const t = Math.min(p.n - (p.name === main ? 12 : 0), cut); if (t > 0) { p.n -= t; cut -= t; } });
          }
          const left = parts.filter((p) => p.n > 0);
          if (left.length > 1) line.properties = { Flavours: left.map((p) => p.n + 'x ' + p.name).join(', ') };
        }
      }
      busy(async () => { await post(`${NJS.routes.cart_url}/change.js`, { id: item.dataset.key, quantity: 0 }); await post(NJS.routes.cart_add_url + '.js', { items: [line] }); });
      return;
    }
    const add = e.target.closest('[data-cd-add]');
    if (add) { busy(() => post(NJS.routes.cart_add_url + '.js', { items: [{ id: Number(add.dataset.cdAdd), quantity: 1 }] })); return; }
    const sl = e.target.closest('[data-cd-slide]');
    if (sl) { const t = r.querySelector('[data-cd-ups]'); t?.scrollBy({ left: Number(sl.dataset.cdSlide) * t.clientWidth * 0.9, behavior: 'smooth' }); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && root()?.getAttribute('aria-hidden') === 'false') close(); });
  document.addEventListener('product:added', async () => { if (!enabled()) return; await render(); open(); });
  document.addEventListener('cart:open', async () => { if (!enabled()) return; await render(); open(); });
  window.NJSCart = { open, close, render };
  /* carts filled elsewhere (another tab, an older visit, the cart page): fix them on page load */
  const boot = async () => {
    if (!(await normalize())) return;
    await render();
    if (document.body.classList.contains('template-cart')) location.reload();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

  } catch(e) { console.error(e); }
})();
})();
